import { useQuery } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';
import type { ScheduleRunFilter } from '../types/schedulerMonitor';

/**
 * GET /scheduler-monitor/schedules/runs — 실행 이력 페이징 (SCHEDULER_READ)
 * queryKey: ['scheduler-monitor', 'runs', filters]
 */
export function useScheduleRuns(filters: ScheduleRunFilter) {
  return useQuery({
    queryKey: ['scheduler-monitor', 'runs', filters],
    queryFn: () =>
      schedulerMonitorApi.listScheduleRuns({
        taskName: filters.taskName || undefined,
        status: filters.status || undefined,
        from: filters.from || undefined,
        to: filters.to || undefined,
        page: filters.page,
        size: filters.size,
        sort: filters.sort,
      }),
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
